import httpClient from "Api/httpClient";

const END_POINT = "/work_orders";

const addBatchToSchedule = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    let POST_ENDPOINT = END_POINT + "/batch/" + payload.work_order_id + "/" + payload.start_date + "/" + payload.end_date + "/" + payload.furnace_id;
    return httpClient.patch(POST_ENDPOINT, body); // useCahe: true, retryTimes: 3, throttle: true
};

const getBatchSchedule = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    let GET_ENDPOINT = END_POINT + "/batch/schedule";
    return httpClient.get(GET_ENDPOINT, body); // useCahe: true, retryTimes: 3, throttle: true
};

const getBatchProductionSchedule = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    let GET_ENDPOINT = END_POINT + "/batch/schedule_by_batch?" + "start_date=" + payload.body.start_date + "&end_date=" + payload.body.end_date;
    return httpClient.get(GET_ENDPOINT); // useCahe: true, retryTimes: 3, throttle: true
};

const deleteBatchFromSchedule = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    let DELETE_ENDPOINT = END_POINT + "/batch/" + payload.work_order_id + "/unschedule";
    return httpClient.delete(DELETE_ENDPOINT); // useCahe: true, retryTimes: 3, throttle: true
};

export { addBatchToSchedule, getBatchSchedule, deleteBatchFromSchedule, getBatchProductionSchedule };
